import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { IPaymentMethodsState, SLICE_NAME } from './models';

const paymentMethodsSelector = (state: RootState): IPaymentMethodsState => state[SLICE_NAME];

export const selectPaymentMethods = createSelector(
  paymentMethodsSelector,
  (state: IPaymentMethodsState) => state.paymentMethods,
);

export const selectPaymentMethodsIsLoading = createSelector(
  paymentMethodsSelector,
  (state: IPaymentMethodsState) => state.isLoading,
);

export const selectPaymentMethodsError = createSelector(
  paymentMethodsSelector,
  (state: IPaymentMethodsState) => state.error,
);
